/** The Timeplanned app's store pages — the one place the web knows them. */
export const APP_STORE_URL = "https://apps.apple.com/app/id6829419503";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.timeplanned.app";

export type StoreId = "app-store" | "google-play";

export interface AppStore {
  id: StoreId;
  url: string;
  /** i18n key of the store's name. */
  nameKey: string;
  /** i18n key of the badge's alt text (the words printed on the official badge). */
  badgeAltKey: string;
}

export const APP_STORES: readonly AppStore[] = [
  { id: "app-store", url: APP_STORE_URL, nameKey: "getTheApp.appStore", badgeAltKey: "getTheApp.appStoreBadgeAlt" },
  { id: "google-play", url: GOOGLE_PLAY_URL, nameKey: "getTheApp.googlePlay", badgeAltKey: "getTheApp.googlePlayBadgeAlt" },
];
